import './styles.scss';
import './styles.modules.scss';
import { MdKeyboardArrowLeft } from '@react-icons/all-files/md/MdKeyboardArrowLeft';
import { MdKeyboardArrowRight } from '@react-icons/all-files/md/MdKeyboardArrowRight';
import React, { useCallback, useState, useRef, MouseEvent } from 'react';
import SwipeableViews from 'react-swipeable-views';
import Lightbox from './Lightbox';
import { ThumbnailList } from './ThumbnailList';
import { getResizeImageUrl } from '~utils/image';

type PreviewData = {
  src: string;
  thumbnailUrl: string;
  type: 'image' | 'video';
};

type PreviewProps = {
  images: PreviewData[];
};

const Preview: React.FC<PreviewProps> = ({ images }) => {
  const [previewImageIndex, setPreviewImageIndex] = useState<number>(0);
  const changePreviewImage = useCallback((imageIndex: number) => {
    setPreviewImageIndex(imageIndex);
  }, []);

  const [isOpenLightbox, setIsOpenLightbox] = useState<boolean>(false);
  const [transformOrigin, setTransformOrigin] = useState({ x: 0, y: 0 });
  const [isHover, setIsHover] = useState(false);

  const previewImageRef = useRef<HTMLDivElement>(null);
  const openLightbox = useCallback(() => {
    if (images.length) {
      setIsOpenLightbox(true);
    }
  }, [images]);
  const closeLightbox = useCallback(() => {
    setIsOpenLightbox(false);
  }, []);

  const handleClickImageSlideButton = (type: 'prev' | 'next') => {
    const updatedImageIndex = () => {
      if (type === 'prev') {
        if (previewImageIndex === 0) return images.length - 1;
        return previewImageIndex - 1;
      } else {
        if (previewImageIndex === images.length - 1) return 0;
        return previewImageIndex + 1;
      }
    };
    setPreviewImageIndex(updatedImageIndex());
  };

  const handleMouseMove = (event: MouseEvent) => {
    const previewImageElement = previewImageRef.current;
    if (!previewImageElement) return;
    const rect = previewImageElement.getBoundingClientRect();
    const { pageX: mouseX, pageY: mouseY } = event;
    const positionX = rect.left + window.pageXOffset;
    const positionY = rect.top + window.pageYOffset;
    const offsetX = mouseX - positionX;
    const offsetY = mouseY - positionY;
    setTransformOrigin({
      x: Math.floor(offsetX),
      y: Math.floor(offsetY),
    });
  };

  // const previewImageStyle = (isHover: boolean) =>
  //   isHover
  //     ? {
  //         transform: ` scale(2.0)`,
  //         transformOrigin: `${transformOrigin.x}px ${transformOrigin.y}px`,
  //       }
  //     : undefined;

  return (
    <>
      <div styleName="ciyashop-product-images">
        <div
          styleName="ciyashop-product-images-wrapper"
          className="ciyashop-product-images-wrapper ciyashop-gallery-style-default ciyashop-gallery-thumb_position-bottom ciyashop-gallery-thumb_vh-horizontal"
        >
          <button
            className="image-slide-button left"
            onClick={() => handleClickImageSlideButton('prev')}
          >
            <MdKeyboardArrowLeft size={16} />
          </button>

          <SwipeableViews
            index={previewImageIndex}
            autoPlay={false}
            loop={true}
          >
            {images.map((image) => (
              <div className="ciyashop-product-gallery ciyashop-product-gallery--with-images slick-carousel">
                <div className="ciyashop-product-gallery__wrapper popup-gallery">
                  <div
                    className="ciyashop-product-gallery__image preview-image"
                    onMouseOver={() => !isHover && setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    onMouseMove={handleMouseMove}
                    ref={previewImageRef}
                  >
                    {image?.type === 'image' && (
                      <img
                        src={
                          image?.src && getResizeImageUrl(image.src, 1200, 1200)
                        }
                        className="img-fluid"
                        onClick={openLightbox}
                        onError={(e: React.InvalidEvent<HTMLImageElement>) =>
                          (e.target.src =
                            'https://placehold.jp/500x200.png?text=No image')
                        }
                        alt="product image"
                        // style={previewImageStyle(isHover)}
                      />
                    )}
                    {image?.type === 'video' && (
                      <video
                        className="img-fluid"
                        controls={true}
                        controlsList="nodownload"
                        playsInline
                      >
                        <source src={image.src} />
                      </video>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </SwipeableViews>

          <div className="clearfix" />

          <button
            className="image-slide-button right"
            onClick={() => handleClickImageSlideButton('next')}
          >
            <MdKeyboardArrowRight size={16} />
          </button>
        </div>
        <div
          className="ciyashop-product-thumbnails"
          styleName="ciyashop-product-thumbnails"
        >
          <ThumbnailList
            images={images}
            previewImageIndex={previewImageIndex}
            changePreviewImage={changePreviewImage}
          />
        </div>
      </div>
      <div>
        {isOpenLightbox && (
          <Lightbox
            images={images
              .filter(({ type }) => type === 'image')
              .map(({ src }) => src)}
            defaultImageIndex={previewImageIndex}
            close={closeLightbox}
          />
        )}
      </div>
    </>
  );
};

export default Preview;
